import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  headingLg: {
    fontSize: theme.fontSizes.xl,
    textAlign: 'center',
    marginBottom: theme.spacings.lg,
  },
  bodyText: {
    fontSize: theme.fontSizes.lg,
    marginBottom: theme.spacings.sm,
  },
  backLink: {
    color: theme.colors.primary,
    textAlign: 'center',
    marginTop: theme.spacings.md,
  },
});
